import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, AlertCircle, CheckCircle2, ArrowLeft } from 'lucide-react';
import { supabase } from '../utils/supabaseClient';
import { validateEmail, sanitizeInput } from '../utils/validation';
import '../styles/auth.css';


const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const clean = sanitizeInput(email);
    if (!validateEmail(clean)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(clean, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setLoading(false);
    // Always show success to avoid revealing whether email exists
    if (!error) setSuccess(true);
    else setSuccess(true); // same UX for security
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-bg-pattern" />
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <svg width="32" height="28" viewBox="0 0 32 28" fill="none">
              <rect x="0" y="8" width="6" height="20" rx="1" fill="#E8471E"/>
              <rect x="9" y="4" width="6" height="24" rx="1" fill="#E8471E"/>
              <rect x="18" y="0" width="6" height="28" rx="1" fill="#E8471E"/>
              <rect x="26" y="6" width="6" height="22" rx="1" fill="#C13010"/>
            </svg>
          </div>
          <span className="auth-logo-text">SYNFIN</span>
        </div>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <CheckCircle2 size={40} color="#E8471E" style={{ marginBottom: '1rem' }} />
            <h2 className="auth-title">Check your inbox</h2>
            <p className="auth-subtitle" style={{ marginBottom: '1.5rem' }}>
              If an account exists for <strong>{email}</strong>, we've sent a password reset link.
            </p>
            <Link to="/login" className="btn-primary" style={{ display: 'flex', textDecoration: 'none' }}>
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <h1 className="auth-title">Reset password</h1>
            <p className="auth-subtitle">Enter your email and we'll send you a reset link</p>

            {error && (
              <div className="auth-error">
                <AlertCircle size={16} /><span>{error}</span>
              </div>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <div className="form-group">
                <label className="form-label" htmlFor="email">Email address</label>
                <input
                  id="email" type="email" className="form-input"
                  placeholder="you@example.com"
                  value={email} onChange={e => setEmail(e.target.value)}
                  required maxLength={254}
                />
              </div>
              <button type="submit"
                className={`btn-primary${loading ? ' btn-loading' : ''}`}
                disabled={loading}>
                {loading ? <span className="btn-spinner" /> : (
                  <><Mail size={18} /> Send reset link</>
                )}
              </button>
            </form>

            <p className="auth-footer-text">
              <Link to="/login" className="auth-link" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                <ArrowLeft size={14} /> Back to sign in
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
